import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators'

import { ServicingService } from '../services/servicing.service';
import { MeasurementService } from '../services/measurement.service';
import { DocumentMangService } from '../services/document_mang.service';

@Injectable({
    providedIn: 'root'
  })

export class ValidateUniquePlancode {

    constructor(
        private servicingService: ServicingService,
        private measurementService: MeasurementService,
        private documentMangService: DocumentMangService,
    ){}

    createValidator(plan_id: number) {

        return (control: AbstractControl) => {

            let data = { action: 'plan_code_check', plan_code: control.value, plan_id: plan_id }

            return this.servicingService.Plancodecheck(data).
                pipe(
                    map(res => {
                        return res.status ? null : { plancodeTaken: true };
                    })
                )
        };
    }

    createCPValidator(plan_id: number) {

        return (control: AbstractControl) => {

            let data = { action: 'plan_code_check', plan_code: control.value, plan_id: plan_id }

            return this.measurementService.Plancodecheck(data).
                pipe(
                    map(res => {
                        return res.status ? null : { plancodeTaken: true };
                    })
                )
        };
    }

    createDMValidator(doc_id: number) {

        return (control: AbstractControl) => {

            let data = { action: 'unique_code', doc_code: control.value, doc_id: doc_id }

            // console.log(data);

            return this.documentMangService.Doccodecheck(data).
                pipe(
                    map(res => {
                        return res.status ? null : { doccodeTaken: true };
                    })
                )
        };
    }
}